export const str = (() => {
    /**
     * 
     * @param {string} str 
     * @returns {boolean}
     */
    function isId(str) {
        return /^[A-Za-z_]([A-Za-z0-9_])*$/gi.test(str);
    }
    /**
     * Check if string is valid uuid
     * @param {string} str
     * @returns {boolean}
     */
    function isUUID(str) {
        return /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi.test(str);
    }
    /**
     * 
     * @param {string} date 
     * @returns {boolean}
     */
    function isValidDate(date) {
        return moment(date, moment.ISO_8601, true).isValid()
    }
    /**
     * 
     * @param {*} str 
     * @returns 
     */
    function isJson(str) {
        try {
            JSON.parse(str)
        } catch (e) {
            return false
        }
        return true
    }
    /**
     * 
     * @param {*} str 
     */
    function isHTML(str){
        return /<\/?[a-z][\s\S]*>/i.test(str)
    }
    
    /**
     * 
     * @param {*} length 
     * @returns {string}
     */
    function getRandom(length){
        let result = ''
        const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        for ( var i = 0; i < length; i++ ) {
            result += charset.charAt(Math.floor(Math.random() * charset.length))
        }
        return result
    }

    function toTitleCase(str) {
        return str.replace(
          /\w\S*/g,
          function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          }
        );
    }

    function toCamelCase(str) {
        return str.replace(/([-_][a-z])/ig, $1 => {
            return $1.toUpperCase()
                .replace('-', '')
                .replace('_', '')
        })
    }

    function toSnakeCase(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
    }

    function toKebabCase(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
    }

    function toPascalCase(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\s+/g, '')
    }

    function toCapitalCase(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\s+/g, '').toUpperCase()
    }
    
    return {
        isId,
        isUUID,
        isJson,
        isHTML,
        isValidDate,
        getRandom,
        toTitleCase,
        toCamelCase,
        toSnakeCase,
        toKebabCase,
        toPascalCase,
        toCapitalCase
    }
})()